module.exports = __webpack_public_path__ + "assets/portrait-default.7e1c4d3c.svg";